import { ElMessageBox } from 'element-plus';
import authApi from './connect';

export const isMobileViewport = () => window.innerWidth <= 768;

export const resolveAssetUrl = (filename) => `${window.location.origin}/assets/${filename}`;

export const resolveDownloadUrl = (filename) => {
  const base = (process.env.VUE_APP_DOWNLOAD_BASE_URL || '/downloads').replace(/\/+$/, '');
  const name = String(filename).replace(/^\/+/, '');
  return `${base}/${name}`;
};

export const triggerDownload = (url, filename) => {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  if (filename) {
    link.download = filename;
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const openInNewTab = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const confirmInstallPackageOnMobile = async () => {
  if (!isMobileViewport()) return true;

  try {
    await ElMessageBox.confirm(
      '此为 Windows 安装包，确定仍要下载？',
      '提示',
      {
        confirmButtonText: '继续下载',
        cancelButtonText: '取消',
        type: 'warning',
      }
    );
    return true;
  } catch {
    return false;
  }
};

export const getInstallPackages = () => {
  // 文件名与体积由 DiCloudAccess.exe 发版时写入 runtime-config.js
  const config = window.RUNTIME_CONFIG || {};
  const packages = config.packages || {};
  const standardFilename = packages.standard?.filename || config.downloadFilename || '';
  const plusFilename = packages.plus?.filename || '';
  const list = [];

  if (standardFilename) {
    list.push({
      id: 'standard',
      label: '标准版',
      size: packages.standard?.size || '体积较小',
      description: '试用推荐。含浏览、编辑、量测、剖面、配准等基础能力。',
      filename: standardFilename,
      recommended: true,
    });
  }

  if (packages.plus) {
    list.push({
      id: 'plus',
      label: 'Plus 版',
      size: packages.plus.size || '体积较大',
      description: '含 AI 分类模型，仅 Plus / 企业授权需要。',
      filename: plusFilename,
      recommended: false,
    });
  }

  return list;
};

export const resolvePlusFilename = async (standardFilename = '') => {
  // runtime-config 由 DiCloudAccess.exe 维护；仅在 Plus 文件名为空时回退接口
  try {
    const response = await authApi.getUpdateInfo();
    const data = response.data || {};
    const filename = data.install_package || data.download_file || '';
    if (filename && filename !== standardFilename) return filename;
  } catch (error) {
    console.error('获取 Plus 安装包信息失败:', error);
  }
  return '';
};
